<template>
  <div class="ccontainer">
    <div class="item-container" :class="{ active: !active }" @click="switchFalse">
      <div class="item">{{ label0 }}</div>
    </div>
    <div class="item-container" :class="{ active }" @click="switchTrue">
      <div class="item">{{ label1 }}</div>
    </div>
    <div class="switch-container">
      <div class="switch" :class="{ active }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CSwitch",
  props: {
    label0: {
      type: String,
      default: "Usuarios",
    },
    label1: {
      type: String,
      default: "Modelos",
    },
    start: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    switchTrue() {
      this.$emit("true");
      this.active = true;
    },
    switchFalse() {
      this.$emit("false");
      this.active = false;
    },
    value() {
      return this.active;
    },
  },
  mounted() {
    this.active = this.start;
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables';

.ccontainer {
  width: 100%;
  padding-block: 0.25em;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  position: relative;

  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  background-color: var(--background_02);
  border-radius: 10px;
  border: 1px solid var(--pallete_main_color);

  &:hover {
    background-color: var(--background_02);
  }

  .item-container {
    width: 50%;
    height: 100%;
    
    z-index: 99;

    cursor: pointer;
    user-select: none;

    color: var(--pallete_main_color);

    transition: color 0.5s ease-in-out;

    &.active {
      color: var(--pallete_over_main_text_color);
    }

    .item {
      width: fit-content;
      margin: 0 auto;
    }
  }

  .switch-container {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: left;
    position: absolute;
    z-index: 9;
    
    .switch {
      width: 50%;
      height: 100%;
      margin: 0;

      border-radius: 10px;
      background-image: linear-gradient(
        to left,
        var(--pallete_degrade_start_color),
        var(--pallete_degrade_finish_color)
      );

      transition: margin-inline 0.5s ease-in-out;

      &.active {
        margin-left: 50%;
      }
    }
  }
}
</style>
